import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary, Grid } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { FormField } from "../../../../../Form/FormField";
import React from "react";

const TagsBasicInformationAccordion: React.FC = () => {
  return (
    <SectionWrapper>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Basic information
        </AccordionSummary>
        <AssetAccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormField
                name="name"
                label="name"
                placeholder="Tag name used in the Admin Portal..."
              />
            </Grid>
          </Grid>
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default TagsBasicInformationAccordion;
